import { render, staticRenderFns } from "./TeacherManagement.vue?vue&type=template&id=01228aa4&lang=pug"
import script from "./TeacherManagement.vue?vue&type=script&lang=ts"
export * from "./TeacherManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports